import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Container } from "semantic-ui-react";

import "./Hubly.css";

import { LoadMinimizeHubResources } from "data/hub/actions";

import { FeatureFlag } from "components/FeatureFlag";

import { useInAppBannerManager } from "./hooks";
import HubModals from "./components/HubModals";
import { HubSetupLoader } from "./components/HubSetupLoader";
import InAppBanner from "./components/InAppBanner";
import RefreshRequiredOverlay from "./components/RefreshRequiredOverlay";
import { Menu as SupportTools } from "./components/Support";
import Workspaces from "./components/Workspace";
import { BookingForm, CommunityForm } from "./components/Workspace/components";
import WorkDeskPreloader from "./components/Workspace/components/WorkDeskPreloader";
import Settings from "../Settings";
import Templates from "../WorkflowTemplatesLibrary";

function Hubly({ hub, advisor, unsyncedUpdates, match, loadResources }) {
  const { showBanner, banner, onDismiss } = useInAppBannerManager();

  if (match.path.endsWith("/welcome/form")) return <CommunityForm />;
  if (match.path.endsWith("/welcome/booking")) return <BookingForm />;

  if (match.path.includes("/settings"))
    return (
      <div
        style={{
          display: "flex",
          height: "calc(100vh - 47px)",
          flexDirection: "column",
        }}
      >
        <InAppBanner visible={showBanner} {...banner} onDismiss={onDismiss} />
        <HubModals match={match} />
        <Settings match={match} />
      </div>
    );

  /*
   * THIS IS A TEMPORARY SOULUTION FOR LOADING UNPAGNATED RESOURCES
   */
  loadResources();

  if (hub.needSetup) {
    return <HubSetupLoader />;
  }

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 47px)",
        justifyContent: "flex-start",
      }}
    >
      <InAppBanner visible={showBanner} {...banner} onDismiss={onDismiss} />
      {unsyncedUpdates > 0 && (
        <RefreshRequiredOverlay unsyncedUpdates={unsyncedUpdates} />
      )}
      <HubModals match={match} />
      <WorkDeskPreloader />
      {match.path.includes("tools") && <SupportTools />}
      <FeatureFlag id="add-to-hub">
        {match.path.includes("/templates") && <Templates />}
      </FeatureFlag>
      <Container fluid basic="true" className="workflow-container">
        <Workspaces hub={hub} advisor={advisor} />
      </Container>
    </div>
  );
}

Hubly.propTypes = {
  loadResources: PropTypes.func.isRequired,
  unsyncedUpdates: PropTypes.number.isRequired,
  hub: PropTypes.object.isRequired,
  advisor: PropTypes.object.isRequired,
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadResources: () => {
      dispatch(LoadMinimizeHubResources());
    },
  };
};

const mapStateToProps = (state) => {
  const { advisor, websockets, hub } = state.hubly.data;

  return {
    advisor: advisor,
    hub: hub.selected.hub,
    unsyncedUpdates: websockets.unsyncedUpdates,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Hubly);
